export const actionTypes = {
  SAVE_ASSETS_USD_VALUES: 'SAVE_ASSETS_USD_VALUES',
  SAVE_POOLS: 'SAVE_POOLS',
  SAVE_ACTIVE_POOL: 'SAVE_ACTIVE_POOL',
  CACHE_ASSET: 'CACHE_ASSET',
  SET_TOP_ASSETS: 'SET_TOP_ASSETS',
};

export const saveAssetUSDValues = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.SAVE_ASSETS_USD_VALUES,
    data: data,
  });
};

export const savePools = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.SAVE_POOLS,
    data: data,
  });
};

export const saveActivePool = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.SAVE_ACTIVE_POOL,
    data: data,
  });
};

export const cacheAsset = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.CACHE_ASSET,
    data: data,
  })
}

export const setTopAssets = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.SET_TOP_ASSETS,
    data: data,
  })
}
